import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-table-cloneable', 'addRow', 'Добавить строку');
Labels.set('ui-table-cloneable', 'removeRow', 'Удалить строку');
